// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#sidebarContainer.zero-top[data-v-4aaa9b0d],#sidebarContent.zero-top[data-v-4aaa9b0d],#viewerContainer.zero-top[data-v-4aaa9b0d]{top:0}", ""]);
// Exports
module.exports = exports;
